import React, { useState } from 'react'

import { VolumeOffIcon, VolumeOnIcon } from '@fourthwall/icons'

import * as S from './Cellphone.styled'
import { Twitter } from './Twitter'
import { VideoShare } from './VideoShare'
import AvatarImage from './assets/avatar@2x.jpg'
import PhoneImage from './assets/phone@2x.png'
import VideoThumbnailImage from './assets/video-thumbnail@2x.jpg'

export interface Props {
  withSound?: boolean
  phoneWidth?: number
}

export const Cellphone = ({ withSound = true, phoneWidth }: Props) => {
  const [muted, setMuted] = useState(true)

  const toggleMuted = () => setMuted((prevMuted) => !prevMuted)

  return (
    <S.Container>
      <S.CellphoneWrapper phoneWidth={phoneWidth}>
        <S.Image src={PhoneImage} />
        <S.VideoContainer>
          <S.Video>
            <video autoPlay loop playsInline muted={muted}>
              <source src="https://cdn.fourthwall.com/marketing/thankyou.mp4" type="video/mp4" />
            </video>
          </S.Video>
        </S.VideoContainer>

        {withSound && (
          <S.MuteWrapper onClick={toggleMuted}>
            {muted ? <VolumeOffIcon /> : <VolumeOnIcon />}
          </S.MuteWrapper>
        )}
      </S.CellphoneWrapper>

      <S.TwitterWidget>
        <Twitter
          avatar={<S.Image src={AvatarImage} />}
          name="Christina T."
          nick="@mildMeihem"
          url="https://beautifulbastard.com/thank-you/ty_IlraEJQiRm6xE5Fxd7swDA"
        >
          <S.TwitterMessage>
            I could listen to @phillyd say my name all fucking day! Literally cried when I saw this,
            thank you!
          </S.TwitterMessage>

          <S.TwitterVideo>
            <VideoShare
              thumbnail={<S.Image src={VideoThumbnailImage} />}
              message="@philyd sent you a message"
              url="beautifulbastard.com"
            />
          </S.TwitterVideo>
        </Twitter>
      </S.TwitterWidget>
    </S.Container>
  )
}
